export default __webpack_public_path__ + "static/media/in500 front.a4fe524d.png";